<div #estimatedDevelopment3AWrapper class="portfolio-box">
  <h2 class="ui-headline">{{ 'new_strategy.portfolio_screen.graph_box.title' | translate }}</h2>
  <p class="estimated-development-subtitle">{{ 'new_strategy.portfolio_screen.graph_box.note-3a' | translate }}</p>

  <app-strategy-stacked-area-chart
    *ngIf="chartData && chartData?.data?.length && chartConfig"
    [data]="chartData"
    [customerLanguage]="customer.language"
    [investedByYear]="chartDataInvestedByYear"
    [config]="chartConfig"
    [translations]="{
      badCase: ('new_strategy.portfolio_screen.graph.columns.bad' | translate),
      expectedCase: ('new_strategy.portfolio_screen.graph.columns.expected' | translate),
      goodCase: ('new_strategy.portfolio_screen.graph.columns.good' | translate),
      year: ('new_strategy.portfolio_screen.graph_box.tooltip.year' | translate),
      investment: ('new_strategy.portfolio_screen.graph_box.tooltip.investment' | translate),
      expectedValue: ('new_strategy.portfolio_screen.graph_box.tooltip.expectedValue' | translate)
    }"
  ></app-strategy-stacked-area-chart>

  <div class="slider-box">
    <p
      [innerHTML]="
        'new_strategy.portfolio_screen.graph_box.calculation_note-3a'
          | translate: { sliderAmount: yearly3aInvestment | translateNumber: customer.language:currentAccount.currency }
      "
    ></p>
    <div class="flex-row">
      <input
        class="blue-slider"
        [(ngModel)]="sliderInvestment"
        type="range"
        [max]="SLIDER_MID * 2"
        [min]="SLIDER_MIN"
        [step]="SLIDER_STEP"
        (input)="getThumbPosition()"
      />
      <div class="thumb" [style.left.%]="thumbPosition"></div>
    </div>
    <div class="flex-row blue-slider-legend">
      <span>
        {{
          'new_strategy.portfolio_screen.graph_box.3aMinimumInvestment'
            | translate: { '3aMinimumInvestmentAmount': MINIMUM_INVESTMENT | translateNumber: customer.language:currentAccount.currency }
        }}</span
      >
      <span *ngIf="currentAccount.step_status <= 2">
        {{ SLIDER_MID | translateNumber: customer.language:currentAccount.currency }}
      </span>
      <span>{{ SLIDER_MAX | translateNumber: customer.language:currentAccount.currency }}</span>
    </div>
  </div>

  <div class="balance-box">
    <div *ngIf="retirementYear">
      <p>
        {{ 'invest.value_after-3a' | translate: { retirementYear: retirementYear } }}
        <strong>{{ totalExpectedReturn | translateNumber: customer.language:currentAccount.currency }}</strong>
      </p>
    </div>
    <p *ngIf="!showMore" class="show-more">
      <a (click)="toggleShowMore(true)">{{ 'strategy.show_more' | translate }}</a>
    </p>
    <ng-container *ngIf="showMore">
      <p class="show-more">
        <a (click)="toggleShowMore(false)">{{ 'strategy.show_less' | translate }}</a>
      </p>

      <div class="expected-return-holder">
        <h4 class="ui-headline">{{ 'strategy.show_more_yearly' | translate }}</h4>
        <div>
          <p
            *ngFor="
              let expectation of [
                ['rb_return', expectedReturnRatio],
                ['rb_gain', expectedPotentialRatio],
                ['rb_loss', expectedLossRatio]
              ];
              let i = index
            "
            class="expectation"
          >
            {{ 'risk.' + expectation[0] | translate }}
            <span *ngIf="i !== 2">+</span>{{ expectation[1] * 100 | translatePercent: customer.language }}
          </p>
        </div>
        <p
          [innerHTML]="
            'risk.box.probability'
              | translate
                : {
                    expectedLossRatio: expectedLossRatio * 100 | translatePercent: customer.language,
                    expectedPotentialRatio: expectedPotentialRatio * 100 | translatePercent: customer.language,
                    expectedReturnRatio: expectedReturnRatio * 100 | translatePercent: customer.language
                  }
          "
        ></p>
      </div>

      <div class="expected-return-holder">
        <h4 class="ui-headline">{{ 'portfolio.estimatedAssetDevelopment.h3.calculation' | translate }}</h4>
        <p>{{ 'new_strategy.portfolio_screen.graph_box.disclaimer' | translate }}</p>
      </div>
    </ng-container>
  </div>
</div>
